import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import UserTabSettings from './UsersTabSettings';
import $ from 'jquery';
import Patient from './Patients';
import ErrorBoundary from '../../ErrorBoundary';

class ViewForProcedureAdminTabSettings extends Component {


  componentDidMount() {
    var thisController = this;
  
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/my-jeeva/projectmgmt";
      var path1 = window.origin + "/my-jeeva/projectmgmt/";
      if (currentPath == path || currentPath == path1 ) {
        $("#staff").addClass('active');
      } else if (currentPath.includes('/projectmgmt/patient') ||
        currentPath.includes('/projectmgmt/patient/')) {
        $("#patient").addClass('active');
      }
      else {
        $("#" + localStorage.getItem("admin-nav-bar-selection")).addClass('active')
      }
      $("#staff, #patient")
        .on("click", function () {
          $("#staff, #patient")
            .removeClass('active');
          localStorage.setItem("last-project-view-for-procedure-admin-tab", $(this)[0].id);

          $(this).addClass('active')

        })



    })();
  }

  render() {
    return (
      <ErrorBoundary>
      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

          <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
          {/* IonIcons */}
          <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <div className="content-header" >
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5" style={{ marginLeft: '0.5vw' }}>
                  <h1 className="m-0 page-title" >Administration</h1>
                </div>

              </div>
            </div>
          </div>

          <div className="container-fluid" >
            {/* Nav tabs */}
            <div className="border-bottom" style={{ marginLeft: '1vw' }}></div>
            <div className="tab-class" style={{ marginLeft: '1vw' }}>

              <ul className="nav nav-tabs border-bottom navCluster">


                <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt" style={{ textDecoration: 'none' }}>
                  <li className="nav-link" id="staff" style={{ marginRight: '15px' }}>
                    Staff
                  </li></Link>
                {/* <Link className="nav-item" data-toggle="tab"
                  to="/projectmgmt/patient" style={{ textDecoration: 'none'}}>
                  <li className="nav-link" id="patient" style={{ marginRight: '15px' }}>
                    Patient
                  </li></Link> */}

              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/projectmgmt/patient" component={Patient}></Route>
          <Route path="/projectmgmt" component={UserTabSettings}></Route>
        </Switch>
      </div>
      </ErrorBoundary>
    );
  }
}
export default ViewForProcedureAdminTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ViewForProcedureAdminTabSettings.js